import {Module} from '@dms/api/shared';
import {moduleKeys} from '@dms/config';
import {inspectionRoutes} from '@dms/routes';
import {permissions} from '@dms/shared';

import {Inspection} from './pages/Inspection/Inspection';

export const InspectionModule: Module = {
  id: moduleKeys.inspection,
  layoutProps: {
    title: 'module.inspection.title',
    icon: 'sidebar/inspection',
  },
  routerProps: {
    path: inspectionRoutes.inspection,
  },
  requiredPermission: permissions.readInspection,
  content: [
    {
      id: 'inspection-module-page',
      routerProps: {
        path: inspectionRoutes.inspection,
        element: <Inspection />,
      },
      layoutProps: {
        title: 'module.inspection.title',
        icon: 'sidebar/inspection',
      },
    },
  ],
};
